import styled from "styled-components";

const FieldRow = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
  display: flex;
  align-items: flex-start;

  :first-of-type {
    margin-top: 0;
  }

  :last-of-type {
    margin-bottom: 0;
  }

  & > :not(:first-child) {
    margin-left: 20px;
  }
`;
export default FieldRow;
